import { motion } from "framer-motion";
import { type ReactNode } from "react";

type Props = {
  kicker: string;
  title: ReactNode;
  blurb?: string;
};

export function SectionHeading({ kicker, title, blurb }: Props) {
  return (
    <div className="mb-12 md:mb-16">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.4 }}
        className="inline-flex items-center gap-2 mb-3 px-2 py-1 border-2 border-witch bg-bruise/60 backdrop-blur-sm"
      >
        <span className="w-2 h-2 bg-acid animate-pulse" />
        <span className="font-display text-[9px] text-mystic tracking-widest uppercase">
          {kicker}
        </span>
      </motion.div>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.5, delay: 0.05 }}
        className="font-display text-2xl md:text-4xl lg:text-5xl leading-tight text-bone"
      >
        {title}
      </motion.h2>
      {blurb && (
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="mt-4 max-w-2xl font-pixel text-lg text-aura/80"
        >
          {blurb}
        </motion.p>
      )}
    </div>
  );
}
